import { lory } from '@rsm/allfarblori';
import h from 'hyperscript';
import iconButton from '../../atoms/icon-button/icon-button';

export default class Gallery {
  constructor($el, options) {
    this.$el = $el;
    this.$slidesFrame = this.$el.querySelector('.gallery__slides-frame');
    this.$slidesContainer = this.$el.querySelector('.gallery__slider');
    this.$slides = this.$el.querySelectorAll('.gallery__slider-item');

    // Bring in the options
    this.options = {
      ...options,
    };

    // Don't init slider, if only one slide exists
    if (this.$slides.length === 1 || this.$el.classList.contains('slider--initialized')) {
      return;
    }

    this.constructGallery();
  }

  deconstructor() {
    if (this.$el.querySelector('.gallery__slider-control--prev')) {
      this.$el.querySelector('.gallery__slider-control--prev').remove();
    }

    if (this.$el.querySelector('.gallery__slider-control--next')) {
      this.$el.querySelector('.gallery__slider-control--next').remove();
    }

    if (this.$el.querySelector('.gallery__slider-thumbs')) {
      this.$el.querySelector('.gallery__slider-thumbs').remove();
    }

    if (this.$el.querySelector('.gallery__slider-caption')) {
      this.$el.querySelector('.gallery__slider-caption').remove();
    }

    if (this.lory) {
      this.lory.destroy();
    }
  }

  constructGallery() {
    this.$el.addEventListener('before.lory.init', () => {
      this.$slidesContainer.scrollLeft = 0;
    });

    this.$el.addEventListener('after.lory.init', () => {
      this.$el.classList.add('slider--initialized');
    });

    this.$el.addEventListener('after.lory.slide', () => {
      this.setCaption();
    });

    this.$el.addEventListener('on.lory.resize', () => {
      if (this.options.sizerTarget) {
        this.imageSizer();
      }
    });

    // Initialize the controls
    this.initControls();

    this.lory = lory(this.$el, {
      rewind: true,
      rewindPrev: true,
      rewindSpeed: 200,
      slideSpeed: 350,
      ease: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
      classNameFrame: 'gallery__slides-frame',
      classNameSlideContainer: 'gallery__slider',
      classNamePrevCtrl: 'gallery__slider-control--prev',
      classNameNextCtrl: 'gallery__slider-control--next',
      classNameDisabledPrevCtrl: 'gallery__slider-control--disabled',
      classNameDisabledNextCtrl: 'gallery__slider-control--disabled',
    });

    // Insert the captions container
    const caption = h(
      '.gallery__slider-caption',
      {
        attrs: {
          'aria-hidden': 'true',
        },
      },
    );
    this.$el.insertBefore(caption, this.$slidesFrame);

    // Insert the thumbnails container
    this.$el.appendChild(h('.gallery__slider-thumbs'));

    if (this.options.sizerTarget) {
      // Conveniently size the images to fit defined 4:3 box
      this.imageSizer();
    }

    // Generate the thumbnails
    this.generateThumbnails();

    // Set the caption
    this.setCaption();
  }

  imageSizer() {
    const slideWidth = this.$slidesFrame.getBoundingClientRect().width;

    this.$slides.forEach(($slide) => {
      const height = slideWidth * 0.75;
      $slide.querySelector(`.${this.options.sizerTarget}`).setAttribute('style', `height: ${height}px`);
    });
  }

  setCaption() {
    const $activeSlide = this.$el.querySelector('.active');
    const caption = $activeSlide.querySelector('figcaption').innerHTML;
    this.$el.querySelector('.gallery__slider-caption').innerHTML = caption;
  }

  initControls() {
    const $controlPrev = iconButton({
      icon: 'hook-left',
      title: 'Vorherige',
      medium: true,
      classes: ['gallery__slider-control', 'gallery__slider-control--prev'],
    });

    const $controlNext = iconButton({
      icon: 'hook-right',
      title: 'Nächste',
      medium: true,
      classes: ['gallery__slider-control', 'gallery__slider-control--next'],
    });

    this.$slidesFrame.appendChild($controlPrev);
    this.$slidesFrame.appendChild($controlNext);
  }

  generateThumbnails() {
    const maxItems = this.options.maxThumbs;
    const totalItems = this.$slides.length;
    // const $thumbsContainer = h('.gallery__slider-thumbs');

    for (let i = 0; i < maxItems; i += 1) {
      if (this.$slides[i]) {
        const $slideImage = this.$slides[i].querySelector('.image__img');
        const isMore = (i === maxItems - 1) && (totalItems > maxItems);

        const $thumb = h(
          'a.gallery__slider-thumb', {
            href: $slideImage.getAttribute('data-src'),
            target: '_blank',
            ariaLabel: $slideImage.getAttribute('alt') !== '' ? (`Klicken, um die Bildanzeige zu wechseln: ${$slideImage.getAttribute('alt')}${isMore ? ` +${totalItems - maxItems} Bilder verfügbar.` : ''}`) : `Klicken, um die Bildanzeige zu wechseln.${isMore ? ` +${totalItems - maxItems} Bilder verfügbar.` : ''}`,
            onclick: (e) => {
              if (i < maxItems - 1) {
                this.lory.slideTo(i);
              } else {
                const $lightboxEl = this.$slides[i].querySelector('.js-lightbox');
                const evt = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window,
                });

                $lightboxEl.dispatchEvent(evt);
              }
              e.preventDefault();
            },
          },
          h(
            'img', {
              src: $slideImage.getAttribute('data-src'),
              alt: $slideImage.getAttribute('alt') ? $slideImage.getAttribute('alt') : '',
              title: $slideImage.getAttribute('title') ? $slideImage.getAttribute('title') : '',
            },
          ),
        );

        if (isMore) {
          const more = totalItems - maxItems;
          const $thumbOverlay = h(
            '.gallery__slider-thumb-overlay',
            `+${more}`,
          );

          $thumb.appendChild($thumbOverlay);
        }

        this.$el.querySelector('.gallery__slider-thumbs').appendChild($thumb);
      }
    }
  }
}

// Trigger Gallery by Breakpoint
const mql = [
  window.matchMedia('(min-width: 480px)'),
  window.matchMedia('(min-width: 768px)'),
  window.matchMedia('(min-width: 1203px)'),
];

let componentStore = [];

export function onMediaQueryChange() {
  componentStore.forEach(component => component.deconstructor && component.deconstructor());
  componentStore = [];

  const isL = mql[2].matches;
  const isM = mql[1].matches;
  const isS = mql[0].matches;

  let maxThumbs = 4;

  if (isL) {
    maxThumbs = 8;
  } else if (isM) {
    maxThumbs = 4;
  } else if (isS) {
    maxThumbs = 3;
  }

  document
    .querySelectorAll('.gallery')
    .forEach(($gallery) => {
      componentStore.push(new Gallery($gallery, {
        maxThumbs,
        sizerTarget: 'figure__media',
      }));
    });
}

mql.forEach(((el) => {
  el.addListener(onMediaQueryChange);
}));

document.addEventListener('DOMContentLoaded', () => {
  onMediaQueryChange();
}, false);
